export default "__VITE_ASSET__BrbT4t_F__"